import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

const firebaseBackend = initializeApp({
    apiKey: "AIzaSyAxRdSYm1W6mQ3d39npaRiBmH6Y3PrgtHQ",
    authDomain: "painttheworld.app",
    projectId: "paint-the-world-7a6b2",
    storageBucket: "paint-the-world-7a6b2.appspot.com",
    messagingSenderId: "1084639947763",
    appId: "1:1084639947763:web:83af55019a8f8ce6c38086",
    measurementId: "G-K33353P81D"
});

export const app = firebaseBackend;
export const auth = getAuth(firebaseBackend);
export const db = getFirestore(firebaseBackend);
// Guard against non-browser environments (Jest, etc.)
export const analytics = typeof window !== 'undefined' ? getAnalytics(firebaseBackend) : null;
export default firebaseBackend;
